import { NgModule, ModuleWithProviders } from '@angular/core';
import { SanitizeHtmlPipe } from './sanitizing.component';


@NgModule({
    imports: [
    ],
    exports: [
        SanitizeHtmlPipe
    ],
    declarations: [
        SanitizeHtmlPipe
    ],
    providers: [
    ]
  })
  export class SanitizingModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
          ngModule: SanitizingModule
        };
      }
  }
